/** Specifies the display state of an element.. */
export const Visibility = {
    Visible: "Visible",
    Hidden: "Hidden",
    Collapsed: "Collapsed"
}

